var map = {
	"./61_stretch.mp3": "1bfb",
	"./62_shake.mp3": "b7fa",
	"./63_pat.mp3": "b9e6",
	"./M_Brilliant.mp3": "170a",
	"./M_Excellent.mp3": "1f3b",
	"./M_Fantastic.mp3": "9f4a",
	"./M_Great.mp3": "a925",
	"./M_Perfect.mp3": "02a2",
	"./M_Think again.mp3": "ff86",
	"./M_Try again.mp3": "bb90",
	"./M_Very good.mp3": "749b",
	"./M_Well done.mp3": "e96f",
	"./M_Work harder.mp3": "c990",
	"./click.mp3": "8138",
	"./false.mp3": "873c",
	"./true.mp3": "5b82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be2c";